import { createTheme } from '@material-ui/core/styles';

const sbFont = "'Nunito',sans-serif";
const sbPfont = "'Nunito',sans-serif";
const secondary = '#90FFBE';
const primary = '#000000';
const simplyGrey = '#606060';
const brightBlue = '#86CDFF';

// A custom theme for this app
const theme = createTheme({
	breakpoints: {
		values: {
			xs: 0,
			sm: 640,
			md: 768,
			lg: 1024,
			xl: 1280,
		},
	},
	palette: {
		type: 'light',
		primary: {
			main: primary,
		},
		secondary: {
			main: secondary,
			contrastText: simplyGrey,
		},
		icon: '#000000',
	},
	status: {
		danger: 'orange',
	},
	typography: {
		htmlFontSize: 16,
		fontSize: 16,
		fontFamily: sbPfont,
		h1: {
			fontFamily: sbFont,
		},
		h2: {
			fontFamily: sbFont,
			fontWeight: 'bold',
		},
		h3: {
			fontFamily: sbFont,
			fontWeight: 'medium',
		},
		h4: {
			fontFamily: sbFont,
			fontWeight: 'medium',
		},
		h5: {
			fontFamily: sbFont,
			fontWeight: 'medium',
		},
		h6: {
			fontFamily: sbFont,
		},
	},
	overrides: {
		MuiButton: {
			contained: {
				padding: '24px 36px 24px 36px',
				borderRadius: '100px 100px 100px 100px',
				color: simplyGrey,
				boxShadow: 'none',
				'&.MuiButton-contained:hover': {
					backgroundColor: brightBlue,
					color: '#fff',
					boxShadow: '0px 6px 8px 8px rgba(0, 0, 0, 0.05);',
				},
			},
			outlined: {
				padding: '24px 36px 24px 36px',
				borderRadius: '100px 100px 100px 100px',
				boxShadow: 'none',
				marginInline: '20px',
			},
		},
	},
	props: {
		MuiButtonBase: {
			disableRipple: true,
			disableTouchRipple: true,
		},
		MuiButton: {
			variant: 'contained',
			size: 'large',
		},
	},
});

export const darkTheme = createTheme({
	palette: {
		type: 'dark',
		primary: {
			main: '#7EB6DD',
		},
		secondary: {
			main: '#FFCF56',
		},
		icon: '#f2f2f2',
	},
	status: {
		danger: 'orange',
	},
	background: {
		extra: '#3c3c3c',
	},
	overrides: {
		MuiButton: {
			contained: {
				backgroundColor: '#7EB6DD',
				color: 'white',
				padding: '0 30px',
				'&:hover': {
					backgroundColor: '#7EB6DD',
					borderColor: '#0062cc',
				},
			},
			outlined: {
				color: '#7EB6DD',
				padding: '0 30px',
				borderRadius: '100',
				'&:hover': {
					borderColor: '#0062cc',
				},
			},
		},
	},
	props: {
		MuiButton: {
			variant: 'contained',
			size: 'small',
		},
	},
});

export default theme;
